import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// Serve the matching worker already in public without CRA transpiling its module.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const PdfViewer = ({ file, title }) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      setWidth(Math.floor(entry.contentRect.width));
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const loading = <p role="status">{t("stakeholder-pdf-loading")}</p>;
  const error = <p role="alert">{t("stakeholder-pdf-error")}</p>;

  return (
    <section className="stakeholder-engagement-plan-pdf" aria-label={title}>
      {numPages > 0 && (
        <nav className="stakeholder-pdf-controls" aria-label={t("stakeholder-pdf-navigation")}>
          <button type="button" disabled={pageNumber <= 1} onClick={() => setPageNumber(pageNumber - 1)}>
            {t("stakeholder-pdf-previous")}
          </button>
          <span aria-live="polite">
            {t("stakeholder-pdf-page", { page: pageNumber, total: numPages })}
          </span>
          <button type="button" disabled={pageNumber >= numPages} onClick={() => setPageNumber(pageNumber + 1)}>
            {t("stakeholder-pdf-next")}
          </button>
        </nav>
      )}
      <div ref={containerRef}>
        <Document
          file={file}
          loading={loading}
          error={error}
          onLoadSuccess={({ numPages: total }) => setNumPages(total)}
          onItemClick={({ pageNumber: targetPage }) => setPageNumber(targetPage)}
        >
          {width > 0 && (
            <Page pageNumber={pageNumber} width={width} loading={loading} error={error} />
          )}
        </Document>
      </div>
    </section>
  );
};

export default PdfViewer;
